import { render, staticRenderFns } from "./ImageSelector.vue?vue&type=template&id=0ef97a38&scoped=true&"
import script from "./ImageSelector.vue?vue&type=script&lang=js&"
export * from "./ImageSelector.vue?vue&type=script&lang=js&"
import style0 from "./ImageSelector.vue?vue&type=style&index=0&id=0ef97a38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef97a38",
  null
  
)

export default component.exports